<template>
  <div>
    <Form
      ref="resourceOptimizationForm"
      :model="resourceOptimizationForm"
      :rules="ruleValidate"
    >
      <Row :gutter="4" style="margin-bottom: 10px">
        <!-- 公司 -->
        <div v-if="company == 1">
          <Col span="4">
            <FormItem label="" prop="companyId">
              <Select
                v-model="resourceOptimizationForm.companyId"
                filterable
                :placeholder="$t('alarms.common.pleaseSelectCompany')"
                :transfer="true"
                @on-change="changeCompany"
              >
                <Option
                  :value="item.id"
                  v-for="item in companyList"
                  :key="item.id"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
        </div>
        <!-- 账号 -->
        <Col span="4">
          <FormItem label="" prop="accountIds">
            <Select
              v-model="resourceOptimizationForm.accountIds"
              filterable
              multiple
              :max-tag-count="1"
              :placeholder="$t('alarms.common.pleaseSelectAccount')"
              :transfer="true"
              @on-change="changeAccountId(resourceOptimizationForm.accountIds)"
            >
              <Checkbox
                v-model="singleAccount"
                @on-change="selectAccountAll"
                style="display: block; text-align: right"
                v-if="accountList.length > 0"
                >{{ $t("Bill.Billing.selectAll") }}</Checkbox
              >
              <Option
                :value="item.id"
                v-for="item in accountList"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <!-- 资源类型 -->
        <Col span="4">
          <FormItem label="" prop="resourceType">
            <Select
              v-model="resourceOptimizationForm.resourceType"
              filterable
              :placeholder="$t('resourceLifecycle.pleaseselecttheresourcetype')"
              :transfer="true"
              @on-change="changeResourceType()"
            >
              <Option
                v-for="(item, index) in resourceTypeList"
                :value="item.id"
                :key="index"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <!-- project -->
        <Col span="4">
          <FormItem label="" prop="projectTag">
            <Select
              v-model="resourceOptimizationForm.projectTag"
              filterable
              :placeholder="$t('Bill.ResourceOptimization.pleaseSelectProjectValue')"
              :transfer="true"
              @on-change="changeProjectTag"
            >
              <Option value="" v-if="projectTagList.length > 0">{{
                $t("configuration_management.common.all")
              }}</Option>
              <Option
                v-for="(item, index) in projectTagList"
                :value="item"
                :key="index"
                >{{ item }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col span="4">
          <FormItem label="" prop="projectTag">
            <Select
              v-model="resourceOptimizationForm.riDataSource"
              filterable
              :placeholder="$t('Bill.ResourceOptimization.RIDataSource')"
              :transfer="true"
              @on-change="handleChangeRi"
            >
              <Option
                v-for="(item, index) in RIList"
                :value="item.id"
                :key="index"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col span="4">
          <Button type="primary" @click="show('resourceOptimizationForm')"
            >{{ $t("alarms.common.search") }}
          </Button>
          <Button
            type="primary"
            :loading="modal_loading"
            v-hasPermission="[
              'ebilling:resourceOptimization:resourceOptimizationDashboard'
            ]"
            @click="exportList('resourceOptimizationForm')"
            >{{ $t("common.export") }}</Button
          >
          <!-- EC2提示 -->
          <Poptip width="200" v-if="resourceOptimizationForm.resourceType == 0">
            <Button>{{ $t('Bill.ResourceOptimization.prompt') }}</Button>
            <div class="api" slot="content">
              <!-- EC2 -->
              <table border="0" cellspacing="0" cellpadding="0">
                <thead>
                  <tr>
                    <th>{{$t('configuration_management.reserved_instance_purchase.size')}}</th>
                    <th>{{ $t("RAM.AWS.RI.RDS.standardizeFactor") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in instanceList" :key="index">
                    <td>{{ item.instanceType }}</td>
                    <td>{{ item.standardizationFactor }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Poptip>
          <!-- RDS提示 -->
          <Poptip
            width="350"
            v-else-if="resourceOptimizationForm.resourceType == 1"
          >
            <Button>{{ $t('Bill.ResourceOptimization.prompt') }}</Button>
            <div class="api" slot="content">
              <!-- RDS -->
              <table border="0" cellspacing="0" cellpadding="0">
                <thead>
                  <tr>
                    <th>{{$t('configuration_management.reserved_instance_purchase.size')}}</th>
                    <th>{{ $t('Bill.ResourceOptimization.singleAvailabilityStandardizedUnit') }}</th>
                    <th>{{ $t('Bill.ResourceOptimization.multiAvailabilityStandardizedUnit') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in rdsList" :key="index">
                    <td>{{ item.instanceType }}</td>
                    <td>{{ item.singleZoneStandardizationUnit }}</td>
                    <td>{{ item.multiAvailabilityAreaStandardizationUnit }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Poptip>
        </Col>
      </Row>
    </Form>
    <table-resource-optimization
      v-if="resourceOptimizationForm.resourceType == 0"
      ref="ec2Child"
    ></table-resource-optimization>
    <table-relational-database-service
      v-if="resourceOptimizationForm.resourceType == 1"
      ref="rdsChild"
    ></table-relational-database-service>
    <table-elasti-cache
      v-if="resourceOptimizationForm.resourceType == 3"
      ref="elastiCacheChild"
    ></table-elasti-cache>
    <table-redshift
      v-if="resourceOptimizationForm.resourceType == 2"
      ref="redShiftChild"
    ></table-redshift>
    <table-elasticsearch
      v-if="resourceOptimizationForm.resourceType == 5"
      ref="elasticsearchChild"
    ></table-elasticsearch>
  </div>
</template>
<script>
import TableResourceOptimization from "../resource_optimization/TableResourceOptimization";
import TableRelationalDatabaseService from "../resource_optimization/TableRelationalDatabaseService";
import TableElastiCache from "../resource_optimization/TableElastiCache";
import TableRedshift from "../resource_optimization/TableRedshift";
import TableElasticsearch from "../resource_optimization/TableElasticsearch";
import { getCookie } from "../../../utils/cookieUtil.js";

export default {
  name: "ResourceOptimizationSearch",
  components: {
    TableResourceOptimization,
    TableRelationalDatabaseService,
    TableElastiCache,
    TableRedshift,
    TableElasticsearch
  },
  data() {
    return {
      RIList: [],
      resourceTypeList: [],
      accountList: [],
      modal_loading: false,
      singleAccount: false,
      company: getCookie(global.companyId),
      companyList: [],
      projectTagList: [],
      instanceList: [
        {
          instanceType: "nano",
          standardizationFactor: "0.25"
        },
        {
          instanceType: "micro",
          standardizationFactor: "0.5"
        },
        {
          instanceType: "small",
          standardizationFactor: "1"
        },
        {
          instanceType: "medium",
          standardizationFactor: "2"
        },
        {
          instanceType: "large",
          standardizationFactor: "4"
        },
        {
          instanceType: "xlarge",
          standardizationFactor: "8"
        },
        {
          instanceType: "2xlarge",
          standardizationFactor: "16"
        },
        {
          instanceType: "3xlarge",
          standardizationFactor: "24"
        },
        {
          instanceType: "4xlarge",
          standardizationFactor: "32"
        },
        {
          instanceType: "6xlarge",
          standardizationFactor: "48"
        },
        {
          instanceType: "8xlarge",
          standardizationFactor: "64"
        },
        {
          instanceType: "9xlarge",
          standardizationFactor: "72"
        },
        {
          instanceType: "10xlarge",
          standardizationFactor: "80"
        },
        {
          instanceType: "12xlarge",
          standardizationFactor: "96"
        },
        {
          instanceType: "16xlarge",
          standardizationFactor: "128"
        },
        {
          instanceType: "18xlarge",
          standardizationFactor: "144"
        },
        {
          instanceType: "24xlarge",
          standardizationFactor: "192"
        },
        {
          instanceType: "32xlarge",
          standardizationFactor: "256"
        },
        {
          instanceType: "56xlarge",
          standardizationFactor: "448"
        },
        {
          instanceType: "112xlarge",
          standardizationFactor: "896"
        }
      ],
      rdsList: [
        {
          instanceType: "nano",
          singleZoneStandardizationUnit: "0.25",
          multiAvailabilityAreaStandardizationUnit: "1"
        },
        {
          instanceType: "small",
          singleZoneStandardizationUnit: "1",
          multiAvailabilityAreaStandardizationUnit: "2"
        },
        {
          instanceType: "medium",
          singleZoneStandardizationUnit: "2",
          multiAvailabilityAreaStandardizationUnit: "4"
        },
        {
          instanceType: "large",
          singleZoneStandardizationUnit: "4",
          multiAvailabilityAreaStandardizationUnit: "8"
        },
        {
          instanceType: "xlarge",
          singleZoneStandardizationUnit: "8",
          multiAvailabilityAreaStandardizationUnit: "16"
        },
        {
          instanceType: "2xlarge",
          singleZoneStandardizationUnit: "16",
          multiAvailabilityAreaStandardizationUnit: "32"
        },
        {
          instanceType: "4xlarge",
          singleZoneStandardizationUnit: "32",
          multiAvailabilityAreaStandardizationUnit: "64"
        },
        {
          instanceType: "6xlarge",
          singleZoneStandardizationUnit: "48",
          multiAvailabilityAreaStandardizationUnit: "96"
        },
        {
          instanceType: "8xlarge",
          singleZoneStandardizationUnit: "64",
          multiAvailabilityAreaStandardizationUnit: "128"
        },
        {
          instanceType: "10xlarge",
          singleZoneStandardizationUnit: "80",
          multiAvailabilityAreaStandardizationUnit: "160"
        },
        {
          instanceType: "12xlarge",
          singleZoneStandardizationUnit: "96",
          multiAvailabilityAreaStandardizationUnit: "192"
        },
        {
          instanceType: "16xlarge",
          singleZoneStandardizationUnit: "128",
          multiAvailabilityAreaStandardizationUnit: "256"
        },
        {
          instanceType: "24xlarge",
          singleZoneStandardizationUnit: "192",
          multiAvailabilityAreaStandardizationUnit: "384"
        },
        {
          instanceType: "32xlarge",
          singleZoneStandardizationUnit: "256",
          multiAvailabilityAreaStandardizationUnit: "512"
        }
      ],
      resourceOptimizationForm: {
        accountIds: [],
        companyId: "",
        projectTag: "",
        resourceType: 0,
        riDataSource: 0
      },
      ruleValidate: {
        projectTag: [
          {
            required: false,
            message: this.$t('Bill.ResourceOptimization.pleaseSelectLabelValue'),
            trigger: "change",
            type: "string"
          }
        ],
        companyId: [
          {
            required: true,
            message: this.$t("configuration_management.common.pleaseSelectCompany"),
            trigger: "change",
            type: "number"
          }
        ],
        accountIds: [
          {
            required: false,
            message: this.$t('Bill.ResourceOptimization.pleaseSelectAccount'),
            trigger: "change",
            type: "array"
          }
        ]
      }
    };
  },
  mounted() {
    if (this.company == 1) {
      // 公司下拉框
      this.getCompanyDropDownBox();
    } else {
      // 账号下拉框
      this.listAccountsByCompanyIdAndCloudPlatformType();
    }
    // 资源类型
    this.resourceTypeBox();
  },
  methods: {
    handleChangeRi(data) {
      if (data == 1) {
        this.$Message.warning(this.$t('Bill.ResourceOptimization.queryMaybeSlow'));
      }
    },
    // 清空
    clear: function() {
      if (this.resourceOptimizationForm.resourceType == 0) {
        this.$refs.ec2Child.tableEC2Data = [];
      } else if (this.resourceOptimizationForm.resourceType == 1) {
        this.$refs.rdsChild.tableRDSData = [];
      } else if (this.resourceOptimizationForm.resourceType == 3) {
        this.$refs.elastiCacheChild.tableElastiCacheData = [];
      } else if (this.resourceOptimizationForm.resourceType == 2) {
        this.$refs.redShiftChild.tableRedShiftData = [];
      } else if (this.resourceOptimizationForm.resourceType == 5) {
        this.$refs.elasticsearchChild.tableElasticsearchData = [];
      }
    },
    // 查询
    show: function(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          if (this.resourceOptimizationForm.resourceType == 0) {
            this.$refs.ec2Child.showEC2All(
              this.resourceOptimizationForm.companyId,
              this.resourceOptimizationForm.accountIds,
              this.resourceOptimizationForm.projectTag,
              this.resourceOptimizationForm.riDataSource
            );
          } else if (this.resourceOptimizationForm.resourceType == 1) {
            this.$refs.rdsChild.showRDSAll(
              this.resourceOptimizationForm.companyId,
              this.resourceOptimizationForm.accountIds,
              this.resourceOptimizationForm.projectTag,
              this.resourceOptimizationForm.riDataSource
            );
          } else if (this.resourceOptimizationForm.resourceType == 3) {
            this.$refs.elastiCacheChild.showElastiCacheAll(
              this.resourceOptimizationForm.companyId,
              this.resourceOptimizationForm.accountIds,
              this.resourceOptimizationForm.projectTag,
              this.resourceOptimizationForm.riDataSource
            );
          } else if (this.resourceOptimizationForm.resourceType == 2) {
            this.$refs.redShiftChild.showRedShiftAll(
              this.resourceOptimizationForm.companyId,
              this.resourceOptimizationForm.accountIds,
              this.resourceOptimizationForm.projectTag,
              this.resourceOptimizationForm.riDataSource
            );
          } else if (this.resourceOptimizationForm.resourceType == 5) {
            this.$refs.elasticsearchChild.showElasticsearchAll(
              this.resourceOptimizationForm.companyId,
              this.resourceOptimizationForm.accountIds,
              this.resourceOptimizationForm.projectTag,
              this.resourceOptimizationForm.riDataSource
            );
          }
        }
      });
    },
    /**************************公司**************************/
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
        });
    },
    // 切换公司
    changeCompany: function() {
      this.resourceOptimizationForm.accountIds = [];
      this.resourceOptimizationForm.projectTag = "";
      this.listAccountsByCompanyIdAndCloudPlatformType();
      this.projectBox();
      this.clear();
    },
    /**************************资源类型**************************/
    // 获取资源类型
    resourceTypeBox: function() {
      this.$api.resourceOptimize.resourceTypeBox().then(res => {
        this.resourceTypeList = res.data;
        this.projectBox();
      });
    },
    // 切换资源类型
    changeResourceType: function() {
      this.projectBox();
      this.resourceOptimizationForm.projectTag = "";
    },
    /**************************标签**************************/
    // 标签值
    projectBox: function() {
      this.$api.resourceOptimize
        .projectBox({
          companyId:
            this.resourceOptimizationForm.companyId == null ||
            this.resourceOptimizationForm.companyId == "" ||
            this.resourceOptimizationForm.companyId == undefined
              ? this.company
              : this.resourceOptimizationForm.companyId,
          resourceType: this.resourceOptimizationForm.resourceType
        })
        .then(res => {
          this.projectTagList = res.data;
          this.getRIData();
        });
    },
    getRIData() {
      this.$api.resourceOptimize.queryRiDataSourceBox().then(res => {
        this.RIList = res.data;
      });
    },
    // 切换标签
    changeProjectTag: function() {
      this.clear();
    },
    /**************************账号**************************/
    listAccountsByCompanyIdAndCloudPlatformType: function() {
      this.$api.account
        .listAccountsByCompanyIdAndCloudPlatformType({
          companyId:
            this.resourceOptimizationForm.companyId == null ||
            this.resourceOptimizationForm.companyId == "" ||
            this.resourceOptimizationForm.companyId == undefined
              ? this.company
              : this.resourceOptimizationForm.companyId,
          type: 0
        })
        .then(res => {
          this.accountList = res.data;
        });
    },
    // 全选
    selectAccountAll() {
      this.resourceOptimizationForm.accountIds = [];
      if (this.singleAccount) {
        this.accountList.map(item => {
          this.resourceOptimizationForm.accountIds.push(item.id);
        });
      } else {
        this.resourceOptimizationForm.accountIds = [];
      }
    },
    // 切换账号
    changeAccountId: function(val) {
      if (val.length === this.accountList.length && val.length != 0) {
        this.singleAccount = true;
      } else {
        this.singleAccount = false;
      }
      this.clear();
    },
    /**************************导出**************************/
    exportList: function(name) {
      // 下载Excel 文件
      this.$refs[name].validate(valid => {
        if (valid) {
          var exportAllList = {
            companyId:
              this.resourceOptimizationForm.companyId == null ||
              this.resourceOptimizationForm.companyId == "" ||
              this.resourceOptimizationForm.companyId == undefined
                ? this.company
                : this.resourceOptimizationForm.companyId,
            projectTag: this.resourceOptimizationForm.projectTag,
            accountIds: this.resourceOptimizationForm.accountIds,
            riDataSource: this.resourceOptimizationForm.riDataSource
          };
          this.modal_loading = true;
          this.$Message.loading({
            duration: 0,
            content: this.$t('common.exporting')
          });
          // 导出EC2
          if (this.resourceOptimizationForm.resourceType == 0) {
            this.$refs.ec2Child.showEC2All(
              this.resourceOptimizationForm.companyId,
              this.resourceOptimizationForm.accountIds,
              this.resourceOptimizationForm.projectTag,
              this.resourceOptimizationForm.riDataSource
            );
            this.$api.resourceOptimize.exportExcel(exportAllList).then(res => {
              this.exportResponse(res);
            });
          }
          // 导出RDS
          else if (this.resourceOptimizationForm.resourceType == 1) {
            this.$refs.rdsChild.showRDSAll(
              this.resourceOptimizationForm.companyId,
              this.resourceOptimizationForm.accountIds,
              this.resourceOptimizationForm.projectTag,
              this.resourceOptimizationForm.riDataSource
            );
            this.$api.resourceOptimize
              .exportRdsExcel(exportAllList)
              .then(res => {
                this.exportResponse(res);
              });
          }
          // 导出ElastiCache
          else if (this.resourceOptimizationForm.resourceType == 3) {
            this.$refs.elastiCacheChild.showElastiCacheAll(
              this.resourceOptimizationForm.companyId,
              this.resourceOptimizationForm.accountIds,
              this.resourceOptimizationForm.projectTag,
              this.resourceOptimizationForm.riDataSource
            );
            this.$api.resourceOptimize
              .exportElasticacheExcel(exportAllList)
              .then(res => {
                this.exportResponse(res);
              });
          }
          // 导出RedShift
          else if (this.resourceOptimizationForm.resourceType == 2) {
            this.$refs.redShiftChild.showRedShiftAll(
              this.resourceOptimizationForm.companyId,
              this.resourceOptimizationForm.accountIds,
              this.resourceOptimizationForm.projectTag,
              this.resourceOptimizationForm.riDataSource
            );
            this.$api.resourceOptimize
              .exportRedshiftExcel(exportAllList)
              .then(res => {
                console.log(res);
                this.exportResponse(res);
              });
          }
          // 导出Elasticsearch
          else if (this.resourceOptimizationForm.resourceType == 5) {
            this.$refs.elasticsearchChild.showElasticsearchAll(
              this.resourceOptimizationForm.companyId,
              this.resourceOptimizationForm.accountIds,
              this.resourceOptimizationForm.projectTag,
              this.resourceOptimizationForm.riDataSource
            );
            this.$api.resourceOptimize
              .exportElasticsearchExcel(exportAllList)
              .then(res => {
                this.exportResponse(res);
              });
          }
        }
      });
    },
    exportResponse: function(res) {
      let fileName = this.$t('Bill.ResourceOptimization.title') + ".xls";
      let blob = new Blob([res.data], { type: "application/x-xls" });
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(link.href);
      }
      this.modal_loading = false;
      this.$Message.destroy();
      this.$Message.success(this.$t('common.exportSuccess'));
    }
  }
};
</script>
<style scoped>
.ivu-form-item {
  margin-bottom: 11px !important;
  vertical-align: top;
  zoom: 1;
}
.api table {
  font-family: Consolas, Menlo, Courier, monospace;
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
  height: 400px;
  display: block;
}
.api table th {
  background: #f7f7f7;
  white-space: nowrap;
  color: #5c6b77;
  font-weight: 600;
}
.api table td,
.api table th {
  border: 1px solid #e9e9e9;
  padding: 5px 7px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/ebilling/resource_optimization/ResourceOptimizationSearch.vue